import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Edit, Eye, Trash2 } from "react-feather";
import TooltipIcons from "../../common/tooltip-content/tooltipIcons";
import RefreshIcon from "../../common/tooltip-content/refresh";
import CollapesIcon from "../../common/tooltip-content/collapes";
import { useDeleteCustomerMutation, useGetAllCustomerQuery } from "../../redux/api/userApi";
import Table from "../../pagination/datatable";
import CustomerModal from "./customerModal";

const CustomerList = () => {
  const {data: customerResponse, refetch} = useGetAllCustomerQuery();
  const [deleteCustomer] = useDeleteCustomerMutation();
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [isAddMode, setIsAddMode] = useState(false);
  const [deleteCustomerId, setDeleteCustomerId] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  console.log("cusomter", customerResponse)

  const handleDeleteCustomer = async () => {
    console.log("Deleting customer with ID:", deleteCustomerId);
    if (!deleteCustomerId) {
      console.error("No customer ID provided for deletion");
      return;
    }
    
    try {
      await deleteCustomer(deleteCustomerId).unwrap();
      alert("Customer Deleted Successfully");
      refetch(); // Refresh the customer list
    } catch (error) {
      console.error("Delete error:", error);
      alert(`Unable to delete Customer: ${error.message}`);
    } finally {
      setShowDeleteModal(false);
      setDeleteCustomerId(null);
    }
  }
  const openDeleteModal = (id) => {
    setDeleteCustomerId(id);
    setShowDeleteModal(true);
  }

  useEffect(() => {
  const modal = document.getElementById('add-customer');
  if (modal) {
    modal.addEventListener('hidden.bs.modal', () => {
      setSelectedCustomer(null);
      setIsAddMode(true); // Reset to add mode when modal closes
    });
    
    return () => {
      modal.removeEventListener('hidden.bs.modal', () => {});
    };
  }
}, []);
  const columns = [
    {
      title: "Customer Code",
      dataIndex: "customerCode",
      sorter: (a, b) => a.customerCode.length - b.customerCode.length,
    },
    {
      title: "Customer Name",
      dataIndex: "customerName",
      sorter: (a, b) => a.customerName.length - b.customerName.length,
    },

    {
      title: "Phone",
      dataIndex: "phone",
      sorter: (a, b) => a.customer.length - b.customer.length,
    },

    {
      title: "Email",
      dataIndex: "email",
      sorter: (a, b) => a.email.length - b.email.length,
    },

    {
      title: "CreditLimit",
      dataIndex: "creditLimit",
      sorter: (a, b) => a.creditLimit.length - b.creditLimit.length,
    },
    {
      title: "Address",
      dataIndex: "address",
    },
    {
      title: "Action",
      dataIndex: "action",
          render: (_,record) => (
              <div className="action-table-data">
                <div className="edit-delete-action">
                  <div className="input-block add-lists"></div>
      
                  <Link className="me-2 p-2" to="#">
                    <Eye className="feather-view" />
                  </Link>
      
                  <Link
                    className="me-2 p-2"
                    to="#"
                    data-bs-toggle="modal" 
                    data-bs-target="#add-customer"
                    onClick={() => {
                      setSelectedCustomer(record);
                      setIsAddMode(false);     
                    }}
                  >
                    <Edit className="feather-edit" />
                  </Link>
      
                  <Link
                    className="confirm-text p-2"
                    // to="#" data-bs-toggle="modal" data-bs-target="#delete-modal"
                    onClick={(e) => {
                      e.preventDefault();
                      openDeleteModal(record._id);
                    }}
                  >
                    <Trash2 className="feather-trash-2" />
                  </Link>
                </div>
              </div>
            ),
      // sorter: (a, b) => a.createdby.length - b.createdby.length,
    },
  ];

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>CustomerList</h4>
                <h6>Manage your CustomerList</h6>
              </div>
            </div>
            <ul className="table-top-head">
              <TooltipIcons />
              <RefreshIcon />
              <CollapesIcon />

            </ul>
            <div className="page-btn">
              <Link
                to="#"
                className="btn btn-primary"
                data-bs-toggle="modal"
                data-bs-target="#add-customer"
                onClick={() => {
                  setSelectedCustomer(null); // Clear selection
                  setIsAddMode(true);       // Set to add mode
                }}
              >
              <i className='ti ti-circle-plus me-1'></i>
                Add Customer
              </Link>
            </div>
          </div>
          {/* /product list */}
          <div className="card table-list-card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
              <div className="search-set">
              </div>
              <div className="d-flex table-dropdown my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                <div className="dropdown me-2">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-white btn-md d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                     Status
                  </Link>
                  <ul className="dropdown-menu  dropdown-menu-end p-3">
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        Active
                      </Link>
                    </li>
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        Inactive
                      </Link>
                    </li>
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        New Joiners
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="card-body">
              <div className="table-responsive">
                <Table
                  className="table datanew"
                  columns={columns}
                  dataSource={customerResponse}
                  key={customerResponse?._id}
                  // rowKey={(record) => record.id}
                />
              </div>
            </div>
          </div>
          {/* /product list */}
        </div>
      </div>

            <CustomerModal
        isEdit={!isAddMode}          // true=edit, false=add
        customerData={selectedCustomer} // null=add, object=edit
        onSuccess={() => {
          // Refresh data after success
          // alert(isAddMode ? "Customer created!" : "Customer updated!");
          // setSelectedCustomer(null);
          refetch(); // Refresh the customer list
        }}
      />
       {/* <CustomerModal/> */}
       


       {showDeleteModal && (
        <div className="modal fade show" id="delete-modal" style={{display: 'block'}}>
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content p-5">
              <div className="modal-body text-center p-0">
                <span className="rounded-circle d-inline-flex p-2 bg-danger-transparent mb-2">
                  <i className="ti ti-trash fs-24 text-danger" />
                </span>
                <h4 className="fs-20 text-gray-9 fw-bold mb-2 mt-1">
                  Delete Customer
                </h4>
                <p className="text-gray-6 mb-0 fs-16">
                  Are you sure you want to delete this customer?
                </p>
                <div className="d-flex justify-content-center mt-3">
                  <button
                    className="btn me-2 btn-secondary fs-13 fw-medium p-2 px-3 shadow-none"
                    onClick={() => setShowDeleteModal(false)}
                  >
                    Cancel
                  </button>
                  <button
                    className="btn btn-primary fs-13 fw-medium p-2 px-3"
                    onClick={handleDeleteCustomer}
                  >
                    Yes Delete
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>

  );
};

export default CustomerList;
